// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from '../TEMPLATE'

export const Boosty = createSinglePathSVG({
  path: 'M2.661 14.337 6.801 0h6.362L11.88 4.444l-.038.077-3.378 11.733h3.15q-1.982 4.934-3.086 7.733c-5.816-.063-7.442-4.228-6.02-9.155M8.554 24l7.67-11.035h-3.25l2.83-7.073c4.852.508 7.137 4.33 5.791 8.952C20.16 19.81 14.344 24 8.68 24h-.127z',
  viewBox: '0 0 24 24',
  glyph: 'Boosty',
})
